import { render, staticRenderFns } from "./RibbonOverlay.vue?vue&type=template&id=26622368&"
import script from "./RibbonOverlay.vue?vue&type=script&lang=ts&"
export * from "./RibbonOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports